import { useState } from 'react'
import { Typography, Radio } from '@mui/material'
import {
  AccessPointIcon,
  ChevronLeftIcon,
  MeetIcon,
  TribuneIcon,
} from '@weblite/icons'
import { BottomDrawer } from '$common/bottom-drawer'
import { t } from '$i18n'
import { SecondaryButton } from '$common/buttons/secondary-button'
import {
  ButtonContent,
  ButtonContentHeader,
  CallTypeButton,
  CallTypeButtons,
  Root,
  StyledCheckCircleIcon,
} from '../shared/components'

export type GroupCallType = 'live' | 'tribune' | 'group_call'
interface Item {
  title: string
  description: string
  icon: JSX.Element
  value: GroupCallType
  limit?: number
}
const items: Item[] = [
  {
    title: t('call.group_call'),
    description: t('chooseChannelCallModal.groupCallDescription'),
    icon: <MeetIcon />,
    value: 'group_call',
    limit: 20,
  },
  {
    title: t('call.live'),
    description: t('chooseChannelCallModal.liveDescription'),
    icon: <AccessPointIcon />,
    value: 'live',
  },
  {
    title: t('call.tribune'),
    description: t('chooseChannelCallModal.tribuneDescription'),
    icon: <TribuneIcon />,
    value: 'tribune',
  },
]

export interface Props {
  isOpen?: boolean
  onConfirm: (callType: GroupCallType) => unknown
  onCancel: () => unknown
}
export function ChooseGroupCall({
  isOpen = false,
  onConfirm,
  onCancel,
}: Props) {
  const [selectedCall, setSelectedCall] = useState<GroupCallType>('live')

  return (
    <BottomDrawer isOpen={isOpen} onClose={onCancel}>
      <Root>
        <Typography variant="subtitle1" color="secondary700">
          {t('chooseChannelCallModal.title')}
        </Typography>

        <CallTypeButtons>
          {items.map(({ title, description, icon, value, limit }) => (
            <CallTypeButton
              data-call-type={value}
              data-selected={selectedCall === value}
              onClick={() => setSelectedCall(value)}
              key={value}
            >
              <ButtonContent>
                <ButtonContentHeader
                  data-call-type={value}
                  data-selected={selectedCall === value}
                >
                  {icon}
                  <Typography variant="subtitle1" color="inherit">
                    {title}
                  </Typography>
                </ButtonContentHeader>
                <Typography color="neutral900" variant="body2">
                  {description}{' '}
                  {limit && (
                    <Typography
                      component="span"
                      variant="caption1"
                      color="neutral600"
                    >
                      ({t('chooseChannelCallModal.callLimit')(limit)})
                    </Typography>
                  )}
                </Typography>
              </ButtonContent>
              <Radio
                checked
                checkedIcon={
                  <StyledCheckCircleIcon
                    data-selected={selectedCall === value}
                  />
                }
              />
            </CallTypeButton>
          ))}
        </CallTypeButtons>

        <SecondaryButton
          fullWidth
          text={t('common.resume')}
          sx={{ height: '48px' }}
          onClick={() => onConfirm(selectedCall)}
          endIcon={<ChevronLeftIcon />}
        />
      </Root>
    </BottomDrawer>
  )
}
